<template>

    <div id="TaskGroup">
        
        <!-- Leave Task -->
        <v-list v-if="leaveTask.length > 0 ">
            <v-list-group value="true">
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-col cols="9" sm="9" md="9">
                            <v-list-item-title>{{$t('selfservicemytask.leaveapplication')}}</v-list-item-title>
                        </v-col>
                        <v-col cols="3" sm="3" md="3">
                            <v-select
                                :items="actionButton"
                                class="mb-n6 mt-2"
                                :label="actionButtonLabel"
                                @input="$emit('leave-action', $event, leaveTask)"
                                dense
                                outlined
                                @click.stop
                                clearable
                            ></v-select>
                        </v-col>
                    </v-list-item-content>
                </template>

                <!-- Select All Row -->
                <v-list-item dense :class="{ 'dark-bg': false }">
                    <v-list-item-content>
                        {{$t('claimbalancemobile.selectall')}} <!-- e.g., "Select All" -->
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-checkbox 
                            v-model="selectAllLeaveLocal" 
                            @change="$emit('select-all-leave', selectAllLeaveLocal)" 
                        ></v-checkbox>
                    </v-list-item-action>
                </v-list-item>

                <!-- Original leave task rows -->
                <v-list-item v-for="(item, index) in leaveTask" :key="index" dense :class="{ 'dark-bg': index % 2 !== 0 }">
                <v-list-item-content @click="$emit('leave-route-details', item)">{{item.psnname}} {{item.ttype}} {{$t('homemobile.timerelatedon')}} {{item.entrytime}}</v-list-item-content>
                    <v-list-item-action>
                        <v-checkbox v-model="item.active"></v-checkbox>
                    </v-list-item-action>
                </v-list-item>
            </v-list-group> 
        </v-list>

        <!-- Claim Task -->
        <v-list v-if="claimTask.length > 0">
            <v-list-group value="true">
                <template v-slot:activator>
                    <v-list-item-content>
                        <!-- <v-col cols="9" sm="9" md="9"> -->
                        <v-col cols="9" sm="9" md="9">
                            <v-list-item-title>{{$t('selfservicemytask.claimapplication')}}</v-list-item-title>
                        </v-col>
                        <!-- <v-col cols="3" sm="3" md="3">
                            <v-select
                                :items="actionButton"
                                class="mb-n6 mt-2"
                                :label="actionButtonLabel"
                                @input="$emit('claim-action', $event, claimTask)"
                                dense
                                outlined
                                @click.stop
                                clearable
                            ></v-select>
                        </v-col> -->
                    </v-list-item-content>
                </template>

                <v-list-item v-for="(item, index) in claimTask" :key="index" dense :class="{ 'dark-bg': index % 2 !== 0 }">
                <!-- <v-list-item-content @click="loadClaimDetail(item)">{{item.claimdetails[0].staffname}} {{item.ttype}} {{$t('homemobile.timerelatedon')}} {{item.claimdetails[0].entrytime}}</v-list-item-content> -->
                <v-list-item-content @click="$emit('claim-route', item)">{{item.claimdetails[0].staffname}} {{item.ttype}} {{$t('homemobile.timerelatedon')}} {{item.claimdetails[0].entrytime}}</v-list-item-content>
                    <!-- <v-list-item-action>
                        <v-checkbox v-model="item.active"></v-checkbox>
                    </v-list-item-action> -->
                </v-list-item>
            </v-list-group> 
        </v-list>

        <!-- <v-expansion-panels v-if="KPITask.length > 0">
            <v-expansion-panel>
                <v-expansion-panel-header class="dark-grey-bg">
                    KPI Setting
                </v-expansion-panel-header>
                <v-expansion-panel-content v-for="(item, index) in KPITask" :key="index" style="font-size: 15px;">
                    <span class="cursor-pointer" @click="goToKPI(item)">
                    KPI - <span class="blue--text">{{ item.title }}</span> from <span class="blue--text">{{ item.startdate }}</span> to <span class="blue--text">{{ item.enddate }}</span> is waiting for your review.
                    </span>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels> -->

        <v-list v-if="KPITask.length > 0">
            <v-list-group value="true">
                <template v-slot:activator>
                <v-list-item-content>
                    <v-col cols="9" sm="9" md="9">
                    <v-list-item-title>{{$t('performancemanagement.kpisetting')}}</v-list-item-title>
                    </v-col>
                </v-list-item-content>
                </template>

                <v-list-item
                v-for="(item, index) in KPITask"
                :key="index"
                dense
                :class="{ 'dark-bg': index % 2 !== 0 }"
                >
                <v-list-item-content @click="goToKPI(item)" class="cursor-pointer">
                <div style="font-size: 15px; white-space: nowrap;">
                    {{$t('pmreviewexercisesectioncard.KPI')}} - <span class="blue--text">{{ item.title }}</span> {{$t('reportsparam.for')}} <span class="blue--text">{{ item.staffname }} - {{ item.staffcode }}</span>  {{$t('payrollpivotreport.from')}}
                    <span class="blue--text">{{ item.startdate }}</span>  {{$t('payrollpivotreport.to')}}
                    <span class="blue--text">{{ item.enddate }}</span> {{$t('pmselfservice.waitingreview')}}
                </div>
                </v-list-item-content>
                </v-list-item>
            </v-list-group>
        </v-list>

        <v-list v-if="reviewExerciseTask.length > 0">
            <v-list-group value="true">
                <template v-slot:activator>
                <v-list-item-content>
                    <v-col cols="9" sm="9" md="9">
                    <v-list-item-title>{{$t('pmselfservice.reviewexercise')}}</v-list-item-title>
                    </v-col>
                </v-list-item-content>
                </template>

                <v-list-item
                v-for="(item, index) in reviewExerciseTask"
                :key="index"
                dense
                :class="{ 'dark-bg': index % 2 !== 0 }"
                >
                <v-list-item-content @click="goToReviewExercise(item)" class="cursor-pointer">
                <div style="font-size: 15px; white-space: nowrap;">
                    {{$t('appraisalrecord.review')}} - <span class="blue--text">{{ item.reviewname }}</span> {{$t('reportsparam.for')}} <span class="blue--text">{{ item.staffname }} - {{ item.staffcode }}</span> {{$t('payrollpivotreport.from')}}
                    <span class="blue--text">{{ item.reviewfromdate }}</span> {{$t('payrollpivotreport.to')}}
                    <span class="blue--text">{{ item.reviewuntildate }}</span> {{$t('pmselfservice.waitingreview')}}
                </div>
                </v-list-item-content>
                </v-list-item>
            </v-list-group>
        </v-list>

        <h3 v-if="KPITask.length < 1 && leaveTask.length < 1 && claimTask.length < 1 && reviewExerciseTask.length < 1" class="pl-4 pt-3 pb-2">{{$t('homemobile.notask')}}</h3>


    </div>

</template>

<script>

export default {
    
    props: {
        leaveTask: Array,
        claimTask: Array,
        KPITask: Array,
        reviewExerciseTask: Array,
        actionButton: Array,
        actionButtonLabel: String
    },
    data() {
        return {
            selectAllLeaveLocal: false
        }
    },

    methods: {
        goToKPI(kpi) {
            console.log("KPI: ", kpi);
            this.$router.push({ name: "selfservicekpidetails", params: { kpi : kpi} });
        },

        goToReviewExercise(review) {
            console.log("RV: ", review);
            this.$router.push({ name: "selfservicereviewdetails", params: { review : review } });
        },
    }

}
</script>